export * from './number-pad.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/number-pad/index.ts